import { IShoppingCarItem } from "app_types/shoppingCart/shoppingCarTypes"

// @export const
export const SCREEN_MODE = 'SCREEN_MODE'
export const EXPAND = 'EXPAND'
export const SIDEBAR_MENU_SELECTED = 'SIDEBAR_MENU_SELECTED'
export const SIDEBAR_COMPONENT = 'SIDEBAR_COMPONENT'
export const CHATBOT_CHANGE = 'CHATBOT_CHANGE'
export const HELPSTEPS_CHANGE = 'HELPSTEPS_CHANGE'
export const SHOPPING_CAR_CHANGE = 'SHOPPING_CAR_CHANGE'
// @end

// @declare interfaces
export interface ISidebarState {
  collapse?: boolean,
  selected?: string
}

export interface IChatbotState {
  open: boolean,
  page: string | null,
  metadata: any
}

export interface IHelpStepsState {
  open: boolean
}

export interface IShoppingCarState {
  items: IShoppingCarItem[]
}

export type ISidebarComponentTypes =
  'admin_dashboard_sidebar' | 'student_dashboard_sidebar' | 'teacher_dashboard_sidebar' | 'account_executive_dashboard_sidebar' | 'company_sidebar' | null

export interface ISidebarComponentState {
  component: ISidebarComponentTypes,
  status: string
}
export interface IAppState {
  chatbot: IChatbotState,
  helpSteps: IHelpStepsState,
  sidebar: ISidebarState
  screenMode: string,
  sidebarComponent: ISidebarComponentState,
  shoppingCart?: {action: IActionsCart, data: IShoppingCarItem[]}
}
// @end

// @declare actions
interface IScreenModeAction {
  type: typeof SCREEN_MODE,
  payload: string
}

interface IExpandAction {
  type: typeof EXPAND
  payload: boolean
}

interface ISidebarComponentAction {
  type: typeof SIDEBAR_COMPONENT
  payload: any
}

interface ISidebarMenuSelectedAction {
  type: typeof SIDEBAR_MENU_SELECTED,
  payload: string
}

interface IChatbotChangeAction {
  type: typeof CHATBOT_CHANGE,
  payload: IChatbotState
}

interface IHelpStepsChangeAction {
  type: typeof HELPSTEPS_CHANGE,
  payload: IHelpStepsState
}

export type IActionsCart = 'add' | 'remove' | 'none'

interface IShoppingCarAction {
  type: typeof SHOPPING_CAR_CHANGE,
  payload: {action: IActionsCart, data: IShoppingCarItem[]},
}
// @end

// @export interfaces
export type AuthActionTypes = IExpandAction | ISidebarMenuSelectedAction | IScreenModeAction | ISidebarComponentAction | IChatbotChangeAction | IHelpStepsChangeAction | IShoppingCarAction
// @end

